import { logoSliderIcon } from './icons';
import attributeVisibility from '@components/visibility/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import logoSliderBlockMeta from './block.json';
import edit from './edit';
import save from './save';
import './style.scss';

const {
  blocks: { registerBlockType },
} = wp;
const { name, ...settings } = logoSliderBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
};

registerBlockType(name, {
  icon: logoSliderIcon,
  ...settings,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
